import React from 'react';
import { Alert } from 'reactstrap';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';

const DomainReplicaWarning = () => {
  return (
    <Alert color="primary">
      <Icon type="warning" className="text-danger" />
      &nbsp;
      <span className="font-weight-bolder text-danger">
        <FMessage id="domain.replicas.warning.title" />
      </span>
      &nbsp; <FMessage id="domain.replicas.warning.text" />
    </Alert>
  );
};

export default DomainReplicaWarning;
